import React, { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const subscribe = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Please enter a valid email");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success("Subscribed!", {
        description: "Welcome aboard! Check your inbox for a welcome email from KYo.",
      });
      setEmail("");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 409) {
        toast.info("Already subscribed", { description: "This email is already on our list." });
      } else {
        toast.error("Could not subscribe", { description: "Please try again shortly." });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="signup">
      {/* Ready to get started */}
      <section className="py-20 text-center scroll-mt-24">
        <div className="max-w-[1240px] mx-auto px-5">
          <h2 className="text-[30px] lg:text-[38px] font-bold text-[#1a1a1a]">Ready To Get Started?</h2>
          <button
            onClick={() => navigate("/signup")}
            className="mt-6 border-2 border-[#ED2E24] text-[#ED2E24] hover:bg-[#ED2E24] hover:text-white font-semibold px-8 py-2.5 rounded-md transition-colors"
            data-testid="cta-signup-btn"
          >
            Sign Up Now!
          </button>
        </div>
      </section>

      {/* Newsletter */}
      <section className="bg-[#ED2E24] py-16">
        <div className="max-w-[720px] mx-auto px-5 text-center">
          <h2 className="text-[28px] lg:text-[36px] font-bold text-white leading-tight">
            Join our newsletter for the latest from KYo Group
          </h2>
          <form
            onSubmit={subscribe}
            className="mt-8 flex w-full max-w-[480px] mx-auto rounded-md overflow-hidden bg-white shadow-lg"
            data-testid="newsletter-form"
          >
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 min-w-0 px-5 py-3.5 text-[14px] text-[#1a1a1a] placeholder:text-gray-400 outline-none"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="shrink-0 whitespace-nowrap bg-[#1a1a1a] hover:bg-black disabled:opacity-70 text-white text-[14px] font-semibold px-5 sm:px-7 transition-colors"
              data-testid="newsletter-subscribe-btn"
            >
              {loading ? "…" : "Subscribe"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
